import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class ArcGisService {

  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient
  ) { }

  RenewArcGisToken(): Observable<any> {
    return this.httpClient.get<any>('api/esri/token', this.httpOptions);
  }

}
